/**
 * @file Landing Dynamic
 */

import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Landing Dynamic component
 */
const vLandingDynamic = () => {
	const landingDynamic = document.querySelector( '.v-landing-dynamic' );

	if ( ! landingDynamic ) {
		return;
	}

	// const visitedTitle   = localStorage.getItem( 'cx-landing-title' );
	const stepsContainer = landingDynamic.querySelector( '.v-landing-dynamic__inner' );

	// if ( ! visitedTitle || visitedTitle === 'default' ) {
	gsap.registerPlugin( ScrollToPlugin );

	const stepTwo        = landingDynamic.querySelector( '.v-landing-dynamic__section--2' );
	const stepThree      = landingDynamic.querySelector( '.v-landing-dynamic__section--3' );
	const stepOneBtn     = landingDynamic.querySelector( '.v-landing-dynamic__cta' );
	const stepThreeTitle = stepThree.querySelector( '.v-landing-dynamic__title' );
	const wpcf7          = stepTwo.querySelector( '.wpcf7' );
	const wpcf7Form      = wpcf7.querySelector( 'form' );

	/**
	 * submits the form
	 */
	const submitFormAjax = () => {
		const formData   = new FormData( wpcf7Form );
		const resultWrap = landingDynamic.querySelector( '.v-landing-dynamic__result-wrap' );

		formData.append( 'current-post', wpPostData.current_post );
		formData.append( 'action', 'v_segment_landing_process_form' );

		axios.post( wpPostData.ajax_url, formData )
			.then( ( { data } ) => {
				if ( data === 'ERROR' ) {
					stepThreeTitle.innerHTML = resultWrap.getAttribute( 'data-default-title' );
					// localStorage.setItem( 'cx-landing-title', 'default' );
				} else {
					stepThreeTitle.innerHTML = data;
					// localStorage.setItem( 'cx-landing-title', data );
				}
			} )
			.catch( () => {
				stepThreeTitle.innerHTML = resultWrap.getAttribute( 'data-default-title' );
				// localStorage.setItem( 'cx-landing-title', 'default' );
			} );
	};

	/**
	 * Changes the dynamic step
	 *
	 * @param {number} nextStep Th next step in the sequence
	 */
	const changeStep = ( nextStep ) => {
		const currentStep    = nextStep - 1;
		stepsContainer.setAttribute( 'data-step', nextStep );
		const nextStepHeight = stepsContainer.getBoundingClientRect().height;
		stepsContainer.setAttribute( 'data-step', currentStep );
		const currentPage    = landingDynamic.querySelector( `.v-landing-dynamic__section--${ currentStep }` );
		const newPage        = landingDynamic.querySelector( `.v-landing-dynamic__section--${ nextStep }` );

		gsap.timeline( {
			defaults: {
				ease:     'sine.inOut',
				duration: .5,
			},
			onComplete: () => {
				gsap.to( window, {
					duration: .5,
					scrollTo: {
						y:       newPage,
						offsetY: 100,
					},
					ease: 'ease.out',
				} );
			},
		} )
			.to( currentPage, {
				opacity: 0,
			} )
			.to( stepsContainer, {
				height:     nextStepHeight,
				onComplete: () => {
					stepsContainer.setAttribute( 'data-step', nextStep );
					stepsContainer.removeAttribute( 'style' );
					newPage.style.opacity = 0;
				},
			} )
			.to( newPage, {
				opacity:    1,
				onComplete: () => {
					newPage.removeAttribute( 'style' );
				},
			} );
	};

	stepOneBtn.addEventListener( 'click', () => changeStep( 2 ) );

	wpcf7.addEventListener( 'wpcf7mailsent', () => {
		wpcf7.querySelector( '.wpcf7-response-output' ).style.display = 'none';
		submitFormAjax();
		changeStep( 3 );
	} );
	/* } else {
		// set step 3 title
		const stepThree          = landingDynamic.querySelector( '.v-landing-dynamic__section--3' );
		const stepThreeTitle     = stepThree.querySelector( '.v-landing-dynamic__title' );
		stepThreeTitle.innerHTML = visitedTitle;

		// change current step to 3
		stepsContainer.setAttribute( 'data-step', 3 );
	} */
};

export default vLandingDynamic;
